import { render, staticRenderFns } from "./DriverEntity.vue?vue&type=template&id=1784e436&scoped=true&"
import script from "./DriverEntity.vue?vue&type=script&lang=js&"
export * from "./DriverEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1784e436",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1784e436')) {
      api.createRecord('1784e436', component.options)
    } else {
      api.reload('1784e436', component.options)
    }
    module.hot.accept("./DriverEntity.vue?vue&type=template&id=1784e436&scoped=true&", function () {
      api.rerender('1784e436', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DriverEntity.vue"
export default component.exports